import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, catchError, filter, finalize, take } from 'rxjs';
import { BANNER_TYPE } from 'src/app/components/banner/banner.constants';
import { ErrorhandleService } from 'src/app/core/services/error-handling/error-handle/errorhandle.service';
import { CommonUtils } from 'src/app/core/utils/common/common.utils';
import { environment } from 'src/app/environments/environment';
import {
  CvisSwap,
  DeleteCvisSwapResponse,
  GetAllCvisSwapsResponse,
} from '../models/cvis-swap.model';
import { EdiSwap } from '../models/edi-swap.model';

@Injectable({
  providedIn: 'root',
})
export class CvisSwapService {
  private readonly http = inject(HttpClient);
  private readonly commonUtils = inject(CommonUtils);
  private readonly errorHandler = inject(ErrorhandleService);

  private readonly baseUrl = environment.apiUrl.concat(
    '/sci-cvis-swap-service/cvis-swap/',
  );
  getCvisSwap(): Observable<GetAllCvisSwapsResponse> {
    this.commonUtils.updateLoadingModal(true);
    return this.http.get<GetAllCvisSwapsResponse>(this.baseUrl, {}).pipe(
      take(1),
      catchError((error) =>
        this.errorHandler.handleError<GetAllCvisSwapsResponse>(
          error,
          error.status,
          'SCI CVIS Swap service: Get All Cvis Swaps',
          BANNER_TYPE.TABLE_DATA_ERROR,
        ),
      ),
      finalize(() => {
        this.commonUtils.updateLoadingModal(false);
      }),
    );
  }

  deleteCvis(cvisId: number): Observable<DeleteCvisSwapResponse> {
    this.commonUtils.updateLoadingModal(true);
    const url = `${this.baseUrl}?cvisSwapId=${cvisId}`;

    return this.http.delete<DeleteCvisSwapResponse>(url).pipe(
      take(1),
      catchError((error) =>
        this.errorHandler.handleError<DeleteCvisSwapResponse>(
          error,
          error.status,
          'CVIS Swap Service: Delete CVIS',
          BANNER_TYPE.API_400_ERROR,
        ),
      ),
      filter((value) => !!value),
      finalize(() => {
        this.commonUtils.updateLoadingModal(false);
      }),
    );
  }

  addCvisSwap(data: EdiSwap) {
    this.commonUtils.updateLoadingModal(true);
    return this.http.post(this.baseUrl.concat(''), data).pipe(
      take(1),
      catchError((error) =>
        this.errorHandler.handleError<void>(
          error,
          error.status,
          'Cvis Swap Service: Add Cvis Swap',
          BANNER_TYPE.API_400_ERROR,
        ),
      ),
      finalize(() => {
        this.commonUtils.updateLoadingModal(false);
      }),
    );
  }

  editCvisSwap(data: CvisSwap) {
    this.commonUtils.updateLoadingModal(true);
    return this.http.put(this.baseUrl.concat(''), data).pipe(
      take(1),
      catchError((error) =>
        this.errorHandler.handleError<void>(
          error,
          error.status,
          'Cvis Swap Service: Edit Cvis Swap',
          BANNER_TYPE.API_400_ERROR,
        ),
      ),
      finalize(() => {
        this.commonUtils.updateLoadingModal(false);
      }),
    );
  }
}
